import _DialogTitle from "@mui/material/DialogTitle";
import _Dialog from "@mui/material/Dialog";
import _DialogActions from "@mui/material/DialogActions";
import _DialogContent from "@mui/material/DialogContent";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import _Typography from "@mui/material/Typography";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import BikeStationAvailabilities from './bike-station-availabilities';
import BikeStationHistoryChart from './bike-station-history-chart';
import { Button } from './button';
export function BikeStationDialog({
  search,
  bikeStation: _bikeStation,
  onUpdated,
  onSearchUpdated,
  ...props
}) {
  const [bikeStation, setBikeStation] = useState(_bikeStation);
  const [history, setHistory] = useState();
  const {
    enqueueSnackbar
  } = useSnackbar();
  useEffect(() => {
    setBikeStation(_bikeStation);
  }, [_bikeStation]);
  function handleLeaveFromHere() {
    if (!bikeStation) return;
    search?.wayPoints.splice(0, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  function handleGoThere() {
    if (!bikeStation) return;
    search?.wayPoints.splice(-1, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), /*#__PURE__*/React.createElement(StyledDialogTitle, null, bikeStation?.label || '', /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, bikeStation?.location.address)), /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), /*#__PURE__*/React.createElement(_DialogContent, null, bikeStation && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BikeStationAvailabilities, {
    bikeStation: bikeStation,
    enqueueSnackbar: enqueueSnackbar,
    onUpdated: onUpdated,
    setBikeStation: setBikeStation,
    setHistory: setHistory
  }), /*#__PURE__*/React.createElement(BikeStationHistoryChart, {
    bikeStation: bikeStation,
    history: history
  }))), search && /*#__PURE__*/React.createElement(_DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    onClick: handleLeaveFromHere,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.leave_from_here"
  })), /*#__PURE__*/React.createElement(Button, {
    color: "inherit",
    onClick: handleGoThere,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.go_there"
  }))));
}
const StyledDialogTitle = styled(_DialogTitle)`
  && {
    padding-right: 46px;
  }
`;
const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;